import Header from "../components/templates/Header"
import { useDispatch,useSelector } from 'react-redux'
import CustomAlert from "../components/alert/CustomAlert";

const Template = (props) => {
    const alert_config = useSelector(state=>state.alert.alert_config);
    return (
        <>
        <Header />
        <CustomAlert success={alert_config.success} danger={alert_config.danger} showModel={alert_config.show_alert} title={alert_config.title} message={alert_config.message} />
        {
            props.component
        }
        </>
    )
}

export default Template